import { render } from "./TheForm.vue?vue&type=template&id=1a6051cf&scoped=true"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"

import "./TheForm.vue?vue&type=style&index=0&id=1a6051cf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6051cf"]])

export default __exports__